import React, { Component } from 'react';
import './Main.css'
import $ from 'jquery';
import { renderContents } from './default';

class Main extends Component {
    componentDidMount() {
        $('body').css('background-image', 'none');
        $('body').css('overflow', 'visible');

        document.querySelector('body').setAttribute( 'oncontextmenu', '' );
        document.querySelector('body').setAttribute( 'onselectstart', '' );
        document.querySelector('body').setAttribute( 'ondragstart', '' );

        renderContents();
    }

    render(){
      return (
        <div id="home" className="animated fadeIn">
            <div id="header-wrapper">
                <div id="header">
                    <div id="logo">
                        <h1><a href="/">Portfolio</a></h1>
                    </div>
                    <div id="menu">
                        <ul className="style2">
                            {/* <li><a href="#" accessKey="contents_home" title="">Home</a></li> */}
                        </ul>
                    </div>
                </div>
            </div>
            
            <div id="wrapper">
                <div id="page-wrapper">
                    <div id="page">
                        <div id="wide-content">
                            <div id="contents">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="footer" className="container">
                <p>&copy; Untitled. All rights reserved. Design by <a href="http://templated.co" rel="nofollow">TEMPLATED</a>. Photos by <a href="http://fotogrph.com/">Fotogrph</a>.</p>
            </div>
        </div>
      );
    }
}

export default Main;